module.exports = __webpack_public_path__ + "img/icon (4).604f7c72.png";